import { required, isEmail, isValid, isMaxCharacter } from "./_validator";
import { FormState, FieldState } from 'formstate/src';

/**
 * 获取信用卡的月
 */
export const getExpMonth = () => {
    var months = [];
    for (var i = 1; i <= 12; i++) {
        months.push(i);
    }
    return months;
}
/**
 * 获取行用卡的年
 */
export const getExpYear = () => {
    var year = new Date().getFullYear(), years = [];
    for (var i = 0; i < 12; i++) {
        years.push(i + year);
    }
    return years;
}


var now = new Date();


function none_validator(val) {
    return false;
}

export default class PuchaserForm {

    customer_first_name = new FieldState('').validators(required(), isMaxCharacter(64));

    customer_last_name = new FieldState('').validators(required(), isMaxCharacter(64));

    customer_email_address = new FieldState('').validators(required(), isEmail());

    customer_phone_number = new FieldState('').validators(required());

    customer_zip_code = new FieldState('').validators(required());

    card_number = new FieldState('').validators(required());
    
    expiry = new FieldState('').validators(required());

    exp_month = new FieldState(now.getMonth()+1);

    exp_year = new FieldState( now.getFullYear());

    cvc = new FieldState('').validators(required());

    agree_terms = new FieldState(true).validators(isValid())


    form: FormState<any>;
    
    enableValidators(prop) {
        this[prop].validators(required());
        return this;
    }
    disableValidators(prop) {
        this[prop].validators(none_validator);
        return this;
    }
    validate() {
        return this.form.validate();
    }

    reset() {
        this.customer_first_name.reinitValue();
        this.customer_last_name.reinitValue();
        this.customer_email_address.reinitValue();
        this.customer_phone_number.reinitValue();
        this.customer_zip_code.reinitValue();
        this.card_number.reinitValue();
        this.agree_terms.reinitValue();
        this.cvc.reinitValue();
    }
    values(): any {
        var result = {};
        for (var key in this.form.$) {
            result[key] = this.form.$[key].$
        }
        return result;
    }

    constructor() {
        var fields: any = this;
        this.form = new FormState({ ...fields });
    }
    static create() {
        return new PuchaserForm();
    }
}



// WEBPACK FOOTER //
// ./src/Apps/ticketing/forms/puchaser.ts